import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import { Colors } from "../../assets/Colors";
import { MenuBuilder } from "../../components/menu/MenuBuilder";

const PayrollPage = ({}) => {
  const navigate = useNavigate();

  let menu = [
    {
      auth: "Payroll",
      name: "Payroll SO (TimeSheet)",
      path: "/payroll/so",
    },
    {
      auth: "Payroll",
      name: "Payroll HO (TimeSheet)",
      path: "/payroll/ho",
    },
    {
      auth: "Payroll",
      name: "Rekap Payroll",
      path: "/rekap-payroll",
    },
  ];

  let Report = [
    {
      auth: "Payroll",
      name: "Pengajuan Payroll SO",
      path: "/payroll/report/SO",
    },
    {
      auth: "Payroll",
      name: "Pengajuan Payroll HO",
      path: "/payroll/report/HO",
    },
  ];

  const [listMenu, setListMenu] = useState(menu);
  const [listReport, setListReport] = useState(Report);

  const filterMenu = (event) => {
    const filtered = menu.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListMenu(filtered);
  };
  const filterReport = (event) => {
    const filtered = Report.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListReport(filtered);
  };

  return (
    <div className="md:ml-64">
      <div className="w-full flex flex-col items-center">
        <div className="w-full px-4 my-4 ">
          <MenuBuilder
            name="Payroll"
            menuController={filterMenu}
            listMenu={listMenu}
          />
          <hr className={"border border-main-100 my-6"} />
          <MenuBuilder
            name="Report"
            menuController={filterReport}
            listMenu={listReport}
          />
        </div>
      </div>
    </div>
  );
};

export default PayrollPage;
